const TRANSIENT_BOTTOM_SHEET_SELECTOR =
  ".color-picker-bottom-sheet, .email-builder-customize-sub-sheet";

function clickCloseButton(root: Element, selector: string): boolean {
  const button = root.querySelector<HTMLElement>(selector);
  if (button === null) {
    return false;
  }

  button.click();
  return true;
}

function findFrontmostTransientBottomSheet(): HTMLElement | null {
  const popups = window.document.querySelectorAll<HTMLElement>(
    ".ui-bottom-sheet-dialog-popup:not([inert])",
  );

  for (let index = popups.length - 1; index >= 0; index -= 1) {
    const popup = popups[index];
    if (popup.getClientRects().length === 0) {
      continue;
    }
    if (popup.matches(TRANSIENT_BOTTOM_SHEET_SELECTOR)) {
      return popup;
    }
  }

  return null;
}

function findOpenMediaSheet(): HTMLElement | null {
  const openSheets = window.document.querySelectorAll<HTMLElement>(".ui-sheet_container--open");
  for (let index = 0; index < openSheets.length; index += 1) {
    const sheetContainer = openSheets.item(index);
    if (sheetContainer?.querySelector(".builder-media-gallery-panel") !== null) {
      return sheetContainer;
    }
  }

  return null;
}

function dismissColorPickerPopover(): boolean {
  const trigger = window.document.querySelector<HTMLElement>(".color-picker-popup-open");
  if (trigger === null) {
    return false;
  }

  trigger.dispatchEvent(
    new PointerEvent("pointerdown", { bubbles: true, cancelable: true }),
  );
  return true;
}

function findFrontmostOpenPopup(): HTMLElement | null {
  const popups = window.document.querySelectorAll<HTMLElement>(".ui-popup_container--open");

  for (let index = popups.length - 1; index >= 0; index -= 1) {
    const popup = popups[index];
    if (popup.getClientRects().length === 0) {
      continue;
    }

    return popup;
  }

  return null;
}

function dismissOpenPopup(): boolean {
  const popup = findFrontmostOpenPopup();
  if (popup === null) {
    return false;
  }

  clickCloseButton(popup, ".ui-popup-close-button button");
  return true;
}

export function tryDismissEmailBuilderOpenSheet(): boolean {
  const openSheets = window.document.querySelectorAll<HTMLElement>(".ui-sheet_container--open");
  for (let index = openSheets.length - 1; index >= 0; index -= 1) {
    const sheet = openSheets.item(index);
    if (sheet !== null && clickCloseButton(sheet, ".ui-popup-close-button button")) {
      return true;
    }
  }

  return false;
}

export function tryDismissEmailBuilderDesignEscapeOverlay(): boolean {
  if (dismissOpenPopup()) {
    return true;
  }

  const bottomSheet = findFrontmostTransientBottomSheet();
  if (
    bottomSheet !== null &&
    clickCloseButton(bottomSheet, ".ui-bottom-sheet-dialog-close")
  ) {
    return true;
  }

  const mediaSheet = findOpenMediaSheet();
  if (
    mediaSheet !== null &&
    clickCloseButton(mediaSheet, ".ui-popup-close-button button")
  ) {
    return true;
  }

  if (tryDismissEmailBuilderOpenSheet()) {
    return true;
  }

  return dismissColorPickerPopover();
}
